import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function VerticalAlignTopIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 24 24">
      <path
        d="M19 5.6q.424 0 .712-.287A.97.97 0 0 0 20 4.6a.97.97 0 0 0-.288-.712A.97.97 0 0 0 19 3.6H5a.97.97 0 0 0-.713.288A.97.97 0 0 0 4 4.6q0 .424.287.713.288.287.713.287zm-7 16q.424 0 .713-.288A.97.97 0 0 0 13 20.6v-9.2l1.9 1.9a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7l-3.6-3.6a.9.9 0 0 0-.325-.212A1.1 1.1 0 0 0 12 8.025q-.2 0-.375.063a.9.9 0 0 0-.325.212l-3.6 3.6a.95.95 0 0 0-.275.7q0 .425.275.7a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275l1.9-1.9v9.2q0 .424.287.712.288.288.713.288"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
